import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function AccountDrop({ target, close, role }) {
    const open = Boolean(target);

    return (
        <Menu
            id="account-menu"
            anchorEl={target}
            open={open}
            onClose={() => close()}
            disableScrollLock
            keepMounted
            sx={{ fontSize: 'small' }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            MenuListProps={{
                'aria-labelledby': 'account-menu-button',
            }}
            slotProps={{
                paper: {
                    sx: { mt: 0.5, minWidth: 140 },
                },
            }}
        >
            <MenuItem onClick={() => close('logout')}>Logout</MenuItem>
        </Menu>
    );
}
